import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinDisplayOverlay } from '@packages/tracking/src/types/events';

export const useCustomerRatingTracking = () => {
  const dispatchTracking = useTracking();

  // RatingInfo
  const trackRatingInfoDisplayOverlay = (label: string) => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: 'dv-service-layer-raiting-info',
        label,
      },
    });
  };

  return {
    trackRatingInfoDisplayOverlay,
  };
};
